import styled from 'styled-components'

export const ChartContainer = styled.div`
  width: 500px;
  height: 300px;
`

export const ValuesContainer = styled.div`
  display: flex;
  justify-content: space-between;
  margin-top: -140px;
  padding-left: ${props => props.theme.spacing.sp16};
  padding-right: ${props => props.theme.spacing.sp16};
  text-align: center;
`
